import React, { useEffect, useState, useRef, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mic, MicOff, X, Sparkles } from 'lucide-react';
import { useTheme } from '../styles/ThemeContext';
type AvatarType = 'human' | 'orb' | 'orb-alt';
type VoiceState = 'idle' | 'listening' | 'speaking';
interface AssistantOverlayProps {
  isActive: boolean;
  onDeactivate: () => void;
}
const MOCK_CONVERSATION: {
  state: VoiceState;
  text: string;
  duration: number;
  speaker: 'ai' | 'you';
}[] = [{
  state: 'idle',
  text: 'Say something to get started...',
  duration: 2500,
  speaker: 'ai'
}, {
  state: 'listening',
  text: 'Listening...',
  duration: 2000,
  speaker: 'you'
}, {
  state: 'speaking',
  text: "Welcome! You're currently in the kitchen. I can see you have the standard countertop selected. Would you like me to show you the premium quartz options?",
  duration: 5000,
  speaker: 'ai'
}, {
  state: 'idle',
  text: 'Say something...',
  duration: 3000,
  speaker: 'ai'
}, {
  state: 'listening',
  text: 'Listening...',
  duration: 2000,
  speaker: 'you'
}, {
  state: 'speaking',
  text: 'Great choice! The Calacatta quartz is our most popular upgrade. Let me navigate you to the living room next.',
  duration: 4000,
  speaker: 'ai'
}];
// ─── SVG Layer Components ───
function BlackSoundwave() {
  return <svg viewBox="0 0 1033.95 1033.95" className="absolute inset-0 w-full h-full" data-id="element-275">
      <path fill="#1e2031" d="M524.6,210.99v74.53h-11.09v-80.79c3.82,1.69,7.46,3.81,11.09,6.26Z" data-id="element-276" />
      <path fill="#1e2031" d="M524.6,741.62v116.35c-3.73-1.62-7.42-3.34-11.09-5.15v-111.19h11.09Z" data-id="element-277" />
      <path fill="#1e2031" d="M506.63,285.79l-11.06.87-6.79-85.99c3.99-.31,7.68-.21,11.14.24l6.7,84.88Z" data-id="element-278" />
      <path fill="#1e2031" d="M552.58,867.89c-3.82-1.04-7.62-2.2-11.4-3.48l-9.72-123.06,11.06-.87,10.06,127.42Z" data-id="element-279" />
      <path fill="#1e2031" d="M488.75,287.47l-10.96,1.75-13.11-82.53c3.52-1.46,7.07-2.7,10.66-3.66l13.41,84.45Z" data-id="element-280" />
      <path fill="#1e2031" d="M581.76,872.99c-3.84-.29-7.65-.73-11.45-1.32l-20.96-132,10.95-1.75,21.46,135.07Z" data-id="element-281" />
      <path fill="#1e2031" d="M471.04,290.55l-10.78,2.6-17.84-74.05c3.26-2.27,6.56-4.38,9.89-6.3l18.72,77.75Z" data-id="element-282" />
      <path fill="#1e2031" d="M611.09,872.08c-3.73.53-7.45.89-11.14,1.09l-32.9-136.59,10.78-2.6,33.26,138.1Z" data-id="element-283" />
      <path fill="#1e2031" d="M453.65,295.03l-10.54,3.44-20.62-63.25c2.99-2.74,6.03-5.38,9.1-7.89l22.07,67.71Z" data-id="element-284" />
      <path fill="#1e2031" d="M639.75,866c-3.49.99-7.08,1.9-10.77,2.74l-44.54-136.63,10.54-3.44,44.76,137.33Z" data-id="element-285" />
      <path fill="#1e2031" d="M436.65,300.85l-10.24,4.26-21.67-52.13c2.75-2.98,5.55-5.9,8.38-8.76l23.53,56.63Z" data-id="element-286" />
      <path fill="#1e2031" d="M667.29,855.82c-3.28,1.55-6.68,3-10.2,4.37l-55.65-133.91,10.25-4.25,55.6,133.79Z" data-id="element-287" />
      <path fill="#1e2031" d="M420.17,308l-9.88,5.04-21.41-41.89c2.54-3.06,5.14-6.12,7.78-9.15l23.51,45.99Z" data-id="element-288" />
      <path fill="#1e2031" d="M692.62,840.85c-2.95,2.18-6.04,4.27-9.25,6.28l-65.44-127.99,9.87-5.04,64.81,126.75Z" data-id="element-289" />
      <path fill="#1e2031" d="M404.3,316.41l-9.45,5.81-20.39-33.17c2.39-3.05,4.84-6.15,7.34-9.25l22.51,36.6Z" data-id="element-290" />
      <path fill="#1e2031" d="M714.43,820.66c-2.48,2.88-5.11,5.67-7.88,8.36l-72.76-118.29,9.44-5.81,71.19,115.75Z" data-id="element-291" />
      <path fill="#1e2031" d="M389.14,326.05l-8.96,6.54-19.14-26.23c2.29-2.97,4.64-6.03,7.06-9.15l21.04,28.84Z" data-id="element-292" />
      <path fill="#1e2031" d="M731.55,795.5c-1.89,3.57-3.93,7.05-6.12,10.43l-76.48-104.85,8.96-6.54,73.63,100.95Z" data-id="element-293" />
      <path fill="#1e2031" d="M374.78,336.86l-8.42,7.22-18.23-21.26c2.26-2.79,4.6-5.75,7.02-8.85l19.63,22.89Z" data-id="element-294" />
      <path fill="#1e2031" d="M743.27,766.47c-1.22,4.16-2.6,8.24-4.12,12.23l-75.84-88.42,8.42-7.22,71.54,83.41Z" data-id="element-295" />
      <path fill="#1e2031" d="M361.32,348.76l-7.82,7.86-18.63-18.55c1.24-1.3,2.37-2.52,3.42-3.67,1.3-1.42,2.65-2.94,4.03-4.55l19,18.92Z" data-id="element-296" />
      <path fill="#1e2031" d="M749.68,735.3h0c-.57,4.58-1.28,9.09-2.14,13.52l-70.77-70.44,7.82-7.87,65.09,64.78Z" data-id="element-297" />
      <path fill="#1e2031" d="M348.85,361.68l-7.18,8.45-20.79-17.66c2.76-2.81,5.36-5.47,7.77-7.95l20.19,17.16Z" data-id="element-298" />
      <path fill="#1e2031" d="M751.57,703.85c0,4.8-.12,9.55-.36,14.24l-61.96-52.63,7.19-8.45,55.13,46.85Z" data-id="element-299" />
      <path fill="#1e2031" d="M337.42,375.55l-6.5,8.99-24.28-17.54c2.69-2.77,5.32-5.44,7.85-8.02l22.93,16.56Z" data-id="element-300" />
      <path fill="#1e2031" d="M751.21,688.09l-50.54-36.5,6.5-8.99,44.18,31.92c-.17,4.51-.22,9.04-.14,13.58Z" data-id="element-301" />
      <path fill="#1e2031" d="M327.12,390.27l-5.77,9.47-29.16-17.75c2.65-2.8,5.28-5.53,7.86-8.2l27.07,16.48Z" data-id="element-302" />
      <path fill="#1e2031" d="M753.51,649.78c-.54,4.05-1,8.1-1.36,12.16l-41.18-25.07,5.77-9.47,36.77,22.38Z" data-id="element-303" />
      <path fill="#1e2031" d="M318.01,405.75l-5,9.89-35.49-17.94c2.61-2.85,5.22-5.68,7.82-8.46l32.66,16.5Z" data-id="element-304" />
      <path fill="#1e2031" d="M757.32,627.78c-.8,3.77-1.52,7.54-2.17,11.33l-35.07-17.73,5-9.9,32.24,16.3Z" data-id="element-305" />
      <path fill="#1e2031" d="M310.15,421.9l-4.21,10.26-43.26-17.74c2.54-2.96,5.12-5.9,7.72-8.82l39.75,16.3Z" data-id="element-306" />
      <path fill="#1e2031" d="M762.28,607.32c-.98,3.6-1.92,7.22-2.8,10.84l-31.54-12.93,4.21-10.26,30.13,12.36Z" data-id="element-307" />
      <path fill="#1e2031" d="M303.59,438.63l-3.39,10.56-52.33-16.79c2.42-3.08,4.91-6.17,7.46-9.26l48.26,15.48Z" data-id="element-308" />
      <path fill="#1e2031" d="M768.19,587.66c-1.15,3.52-2.26,7.05-3.32,10.58l-30.36-9.74,3.39-10.56,30.3,9.72Z" data-id="element-309" />
      <path fill="#1e2031" d="M298.36,455.82l-2.54,10.8-62.21-14.67c2.15-3.22,4.45-6.49,6.86-9.78l57.89,13.66Z" data-id="element-310" />
      <path fill="#1e2031" d="M774.99,568.24c-1.3,3.5-2.57,7-3.79,10.51l-31.46-7.42,2.54-10.8,32.71,7.71Z" data-id="element-311" />
      <path fill="#1e2031" d="M294.5,473.36l-1.69,10.96-71.59-11.03c1.59-3.37,3.44-6.84,5.49-10.38l67.79,10.45Z" data-id="element-312" />
      <path fill="#1e2031" d="M782.71,548.58c-1.45,3.51-2.86,7.03-4.24,10.56l-34.87-5.37,1.69-10.96,37.42,5.77Z" data-id="element-313" />
      <path fill="#1e2031" d="M292.03,491.15l-.82,11.06-76.74-5.69c.15-3.44.83-7.11,1.97-10.98l75.6,5.61Z" data-id="element-314" />
      <path fill="#1e2031" d="M791.4,528.22c-1.58,3.59-3.15,7.17-4.68,10.77l-40.66-3.02.83-11.06,44.51,3.31Z" data-id="element-315" />
      <path fill="#1e2031" d="M291.02,520.18l-67.47.32c-2.32-3.73-4.47-7.42-6.41-11.06l73.83-.35.05,11.09Z" data-id="element-316" />
      <path fill="#1e2031" d="M801.19,506.7c-1.72,3.69-3.43,7.39-5.12,11.11l-48.95.23-.05-11.09,54.11-.25Z" data-id="element-317" />
      <path fill="#1e2031" d="M292.25,538.1l-53.76,4.5c-2.51-3.54-4.97-7.05-7.34-10.51l60.17-5.04.92,11.05Z" data-id="element-318" />
      <path fill="#1e2031" d="M812.16,483.49c-1.84,3.85-3.68,7.71-5.52,11.59l-59.87,5.01-.92-11.05,66.32-5.55Z" data-id="element-319" />
      <path fill="#1e2031" d="M294.89,555.87l-42.2,6.91c-2.34-3.39-4.7-6.76-7.05-10.09l47.45-7.76,1.8,10.94Z" data-id="element-320" />
      <path fill="#1e2031" d="M824.37,457.97c-1.93,4.05-3.87,8.11-5.83,12.19l-73.53,12.04-1.79-10.95,81.16-13.28Z" data-id="element-321" />
      <path fill="#1e2031" d="M298.91,573.38l-33.93,8.34c-2.01-3.34-4.1-6.63-6.23-9.89l37.51-9.22,2.65,10.77Z" data-id="element-322" />
      <path fill="#1e2031" d="M836.44,429.85c-1.3,4.19-2.88,8.39-4.75,12.59l-89.85,22.08-2.65-10.77,97.25-23.91Z" data-id="element-323" />
      <path fill="#1e2031" d="M304.3,590.52l-29.31,9.7c-1.59-3.36-3.31-6.69-5.11-9.99l30.92-10.24,3.49,10.53Z" data-id="element-324" />
      <path fill="#1e2031" d="M840.93,401.13c0,3.95-.26,7.93-.78,11.95l-102.87,34.06-3.48-10.53,107.13-35.48Z" data-id="element-325" />
      <path fill="#1e2031" d="M311.02,607.18l-28.61,12.05c-1.06-3.53-2.31-7.02-3.69-10.49l28-11.79,4.3,10.23Z" data-id="element-326" />
      <path fill="#1e2031" d="M839.39,384.69l-108.01,45.48-4.31-10.23,109.52-46.11c1.17,3.57,2.1,7.19,2.8,10.86Z" data-id="element-327" />
      <path fill="#1e2031" d="M319.03,623.26l-32.54,16.83c-.33-3.91-.91-7.78-1.71-11.6l29.15-15.08,5.1,9.85Z" data-id="element-328" />
      <path fill="#1e2031" d="M830.2,358.88l-106.04,54.85-5.09-9.85,105.36-54.5c2.13,3.11,4.06,6.28,5.78,9.5Z" data-id="element-329" />
      <path fill="#1e2031" d="M328.29,638.66l-40.1,24.92c-.47-4.02-.83-8.15-1.09-12.38l35.33-21.96,5.86,9.42Z" data-id="element-330" />
      <path fill="#1e2031" d="M814.23,336.64l-98.56,61.26-5.86-9.42,96.31-59.86c2.88,2.6,5.58,5.28,8.11,8.02Z" data-id="element-331" />
      <path fill="#1e2031" d="M338.72,653.28l-46.19,34.03c-1.01-3.82-1.87-7.77-2.6-11.86l42.22-31.09,6.58,8.93Z" data-id="element-332" />
      <path fill="#1e2031" d="M793.41,318.35l-87.46,64.43-6.57-8.93,84.23-62.04c3.42,2.11,6.68,4.3,9.81,6.54Z" data-id="element-333" />
      <path fill="#1e2031" d="M350.28,667.04l-49.3,42.69c-1.75-3.36-3.31-6.9-4.7-10.6l46.73-40.47,7.26,8.39Z" data-id="element-334" />
      <path fill="#1e2031" d="M769.59,303.96l-74.51,64.52-7.26-8.39,70.79-61.29c3.79,1.65,7.45,3.37,10.98,5.16Z" data-id="element-335" />
      <path fill="#1e2031" d="M362.88,679.84l-48.24,48.92c-2.62-2.64-5.01-5.47-7.19-8.5l47.53-48.21,7.9,7.79Z" data-id="element-336" />
      <path fill="#1e2031" d="M744.24,293.09l-61.12,61.99-7.9-7.79,57.3-58.11c4.02,1.23,7.92,2.54,11.72,3.92Z" data-id="element-337" />
      <path fill="#1e2031" d="M376.44,691.62l-42.85,50.92c-3.42-1.74-6.62-3.68-9.61-5.81l43.98-52.25,8.48,7.14Z" data-id="element-338" />
      <path fill="#1e2031" d="M718.47,285.23l-48.33,57.43-8.49-7.14,44.7-53.11c4.13.87,8.17,1.82,12.12,2.82Z" data-id="element-339" />
      <path fill="#1e2031" d="M390.9,702.29l-35.19,49.2c-3.52-1.55-7.01-2.91-10.46-4.07-.07-.02-.14-.04-.21-.07l36.83-51.5,9.02,6.46Z" data-id="element-340" />
      <path fill="#1e2031" d="M693.01,279.84l-36.8,51.45-9.02-6.46,33.53-46.88c4.17.57,8.27,1.2,12.29,1.89Z" data-id="element-341" />
      <path fill="#1e2031" d="M406.15,711.79l-30.23,50.19c-3.26-1.92-6.49-3.73-9.69-5.41l30.42-50.51,9.5,5.72Z" data-id="element-342" />
      <path fill="#1e2031" d="M668.32,276.45l-26.87,44.62-9.5-5.72,24.39-40.5c3.87.58,7.86,1.12,11.99,1.6Z" data-id="element-343" />
      <path fill="#1e2031" d="M422.1,720.06l-27.03,54.1c-3.14-2.11-6.25-4.17-9.33-6.14l26.44-52.92,9.92,4.95Z" data-id="element-344" />
      <path fill="#1e2031" d="M645.42,272.99l-19.5,39.04-9.92-4.96,18.19-36.42c3.61.83,7.34,1.61,11.23,2.34Z" data-id="element-345" />
      <path fill="#1e2031" d="M438.65,727.05l-24.48,60.49c-3.12-2.25-6.22-4.46-9.29-6.62l23.49-58.03,10.29,4.16Z" data-id="element-346" />
      <path fill="#1e2031" d="M624.32,268.19l-14.59,36.06-10.29-4.16,14.19-35.07c3.42,1.11,6.97,2.17,10.69,3.17Z" data-id="element-347" />
      <path fill="#1e2031" d="M455.69,732.72l-21.82,69.13c-3.17-2.31-6.32-4.61-9.45-6.88l20.7-65.59,10.57,3.34Z" data-id="element-348" />
      <path fill="#1e2031" d="M604.33,261.79l-11.35,35.97-10.57-3.34,11.62-36.8c3.28,1.43,6.71,2.82,10.31,4.17Z" data-id="element-349" />
      <path fill="#1e2031" d="M473.14,737.02l-18.43,79.8c-3.28-2.31-6.54-4.63-9.78-6.96l17.4-75.34,10.8,2.5Z" data-id="element-350" />
      <path fill="#1e2031" d="M584.84,253.31l-9.07,39.3-10.81-2.49,9.77-42.3c3.19,1.86,6.55,3.7,10.12,5.49Z" data-id="element-351" />
      <path fill="#1e2031" d="M490.86,739.94l-13.74,92.02c-3.42-2.2-6.83-4.45-10.2-6.73l12.98-86.93,10.97,1.64Z" data-id="element-352" />
      <path fill="#1e2031" d="M565.21,241.9l-7,46.94-10.97-1.64,7.83-52.48c3.17,2.38,6.54,4.78,10.15,7.18Z" data-id="element-353" />
      <path fill="#1e2031" d="M508.76,741.46l-7.31,105.09c-3.59-1.97-7.15-4.02-10.69-6.12l6.94-99.73,11.06.77Z" data-id="element-354" />
      <path fill="#1e2031" d="M544.56,226.51l-4.16,59.94-11.07-.77,4.7-67.69c3.37,2.67,6.84,5.53,10.53,8.52Z" data-id="element-355" />
    </svg>;
}
function DarkTealSoundwave() {
  return <svg viewBox="0 0 1033.95 1033.95" className="absolute inset-0 w-full h-full" data-id="element-356">
      <path fill="#116e72" d="M525.11,285.45h-.27l-15.99.15-1.26-138.88c5.41-.34,10.84-.45,16.27-.33l1.21,132.77.06,6.29Z" data-id="element-357" />
      <path fill="#116e72" d="M529.8,800.64c-5.45,3.33-10.85,6.67-16.18,9.99l-.57-62.77-.06-6.18h.27l16-.15.54,59.11Z" data-id="element-358" />
      <path fill="#116e72" d="M507.14,285.68l-16.2,1.43-12.03-136.53c5.34-1.11,10.71-2,16.1-2.68l12.13,137.78Z" data-id="element-359" />
      <path fill="#116e72" d="M551.37,787.78c-5.22,3.02-10.4,6.09-15.52,9.18l-4.89-55.5,16.2-1.43,4.21,47.75Z" data-id="element-360" />
      <path fill="#116e72" d="M489.24,287.33l-16.04,2.69-22.15-131.65c5.18-1.83,10.4-3.47,15.68-4.9l22.51,133.86Z" data-id="element-361" />
      <path fill="#116e72" d="M571.52,776.51c-5.07,2.72-10.11,5.51-15.09,8.35l-7.58-45.06,16.05-2.7,6.63,39.41Z" data-id="element-362" />
      <path fill="#116e72" d="M471.53,290.38l-15.78,3.95-31.21-124.59c4.95-2.51,9.96-4.82,15.03-6.94l31.95,127.59Z" data-id="element-363" />
      <path fill="#116e72" d="M590.82,766.66c-5.01,2.41-9.97,4.92-14.89,7.51l-9.37-37.42,15.78-3.95,8.48,33.85Z" data-id="element-364" />
      <path fill="#116e72" d="M454.12,294.8l-15.43,5.18-38.88-115.71c4.64-3.13,9.38-6.08,14.19-8.84l40.12,119.37Z" data-id="element-365" />
      <path fill="#116e72" d="M609.78,758.05c-5.01,2.12-9.98,4.35-14.92,6.68l-10.88-32.4,15.43-5.18,10.38,30.9Z" data-id="element-366" />
      <path fill="#116e72" d="M437.1,300.59l-14.97,6.37-44.94-105.41c4.28-3.7,8.68-7.22,13.18-10.58l46.73,109.62Z" data-id="element-367" />
      <path fill="#116e72" d="M628.94,750.62c-5.1,1.8-10.17,3.73-15.21,5.8l-12.73-29.87,14.97-6.37,12.98,30.45Z" data-id="element-368" />
      <path fill="#116e72" d="M420.6,307.7l-14.42,7.54-49.2-94.1c3.88-4.22,7.88-8.27,12-12.16l51.61,98.73Z" data-id="element-369" />
      <path fill="#116e72" d="M648.91,744.4c-5.32,1.43-10.6,3.04-15.85,4.81l-15.57-29.77,14.42-7.54,16.99,32.5Z" data-id="element-370" />
      <path fill="#116e72" d="M404.7,316.09l-13.78,8.65-51.56-82.15c3.42-4.67,6.99-9.2,10.69-13.58l54.65,87.08Z" data-id="element-371" />
      <path fill="#116e72" d="M670.52,739.61c-5.68.98-11.34,2.17-16.96,3.58l-20.17-32.14,13.78-8.65,23.35,37.21Z" data-id="element-372" />
      <path fill="#116e72" d="M389.52,325.7l-13.06,9.7-52.01-69.95c2.93-5.08,6.01-10.02,9.25-14.83l55.81,75.08Z" data-id="element-373" />
      <path fill="#116e72" d="M695.2,736.88c-6.34.3-12.64.92-18.92,1.83l-27.71-37.27,13.06-9.7,33.56,45.14Z" data-id="element-374" />
      <path fill="#116e72" d="M375.14,336.47l-12.25,10.7-50.57-57.89c2.41-5.42,4.99-10.72,7.73-15.88l55.1,63.07Z" data-id="element-375" />
      <path fill="#116e72" d="M723.59,735.33c-6.63.72-13.44,1.18-20.45,1.32l-40.18-45.99,12.25-10.7,48.38,55.37Z" data-id="element-376" />
      <path fill="#116e72" d="M361.65,348.35l-11.37,11.63-47.95-46.87c2.18-5.09,4.36-10.32,6.54-15.72.06-.15.12-.3.18-.44l52.59,51.4Z" data-id="element-377" />
      <path fill="#116e72" d="M752.37,730.24c-6.23,1.55-12.67,2.85-19.32,3.86l-56.59-55.31,11.37-11.63,64.55,63.08Z" data-id="element-378" />
      <path fill="#116e72" d="M349.13,361.25l-10.42,12.49-46.26-38.59c2.31-4.95,4.64-10.07,6.97-15.37l49.71,41.46Z" data-id="element-379" />
      <path fill="#116e72" d="M780.42,720.99c-5.69,2.37-11.6,4.51-17.74,6.39l-73.72-61.49,10.42-12.5,81.04,67.59Z" data-id="element-380" />
      <path fill="#116e72" d="M337.67,375.09l-9.41,13.27-45.96-32.57c2.44-4.73,4.89-9.65,7.34-14.74l48.04,34.04Z" data-id="element-381" />
      <path fill="#116e72" d="M806.75,707.45c-5.01,3.13-10.27,6.06-15.78,8.76l-90.55-64.16,9.4-13.27,96.93,68.67Z" data-id="element-382" />
      <path fill="#116e72" d="M327.34,389.79l-8.33,13.98-47.34-28.23c2.59-4.56,5.19-9.32,7.8-14.29l47.87,28.54Z" data-id="element-383" />
      <path fill="#116e72" d="M830.41,689.75c-4.24,3.79-8.75,7.43-13.51,10.88l-106.14-63.28,8.33-13.98,111.32,66.37Z" data-id="element-384" />
      <path fill="#116e72" d="M318.19,405.26l-7.2,14.59-50.79-25.1c2.79-4.43,5.61-9.08,8.46-13.97l49.54,24.48Z" data-id="element-385" />
      <path fill="#116e72" d="M850.44,668.22c-3.36,4.37-7.01,8.62-10.95,12.73l-119.59-59.08,7.21-14.58,123.33,60.93Z" data-id="element-386" />
      <path fill="#116e72" d="M310.29,421.4l-6.03,15.11-56.83-22.7c3.08-4.31,6.2-8.9,9.38-13.77l53.48,21.36Z" data-id="element-387" />
      <path fill="#116e72" d="M865.95,643.41c-2.37,4.83-5.07,9.61-8.08,14.29l-130.06-51.96,6.04-15.11,132.11,52.78Z" data-id="element-388" />
      <path fill="#116e72" d="M303.69,438.11l-4.83,15.54-66.23-20.58c3.49-4.19,7.08-8.75,10.76-13.69l60.3,18.74Z" data-id="element-389" />
      <path fill="#116e72" d="M875.86,615.94h0c-1.22,5.2-2.8,10.4-4.75,15.57l-136.71-42.49,4.83-15.53,136.62,42.45Z" data-id="element-390" />
      <path fill="#116e72" d="M298.42,455.3l-3.59,15.87-80.56-18.23c4.13-3.98,8.51-8.53,13.09-13.72l71.06,16.08Z" data-id="element-391" />
      <path fill="#116e72" d="M878.11,603.17l-138.43-31.33,3.59-15.87,135.46,30.66c.24,5.43.02,10.96-.62,16.54Z" data-id="element-392" />
      <path fill="#116e72" d="M294.51,472.84l-2.33,16.11-104.38-15.11c4.98-3,11.28-7.4,18.63-13.74l88.07,12.75Z" data-id="element-393" />
      <path fill="#116e72" d="M877.26,573.65l-133.67-19.36,2.33-16.1,126.27,18.28c2.29,5.49,3.98,11.25,5.07,17.18Z" data-id="element-394" />
      <path fill="#116e72" d="M292.01,490.64l-1.06,16.23-123.42-8.03c.5-5.97,3.03-11.5,6.98-15.85l117.49,7.65Z" data-id="element-395" />
      <path fill="#116e72" d="M865.87,544.29l-119.79-7.79,1.06-16.23,105.77,6.88c2.46,3.19,5.02,6.46,7.73,9.83,1.89,2.36,3.63,4.8,5.23,7.31Z" data-id="element-396" />
      <path fill="#116e72" d="M291.13,524.84l-112.81,1.55c-4.24-5.41-7.52-10.71-9.32-16.14l121.9-1.68.23,16.26Z" data-id="element-397" />
      <path fill="#116e72" d="M845.49,517.21l-98.3,1.35-.22-16.27,87.35-1.2c3.51,5.32,7.19,10.65,11.17,16.11Z" data-id="element-398" />
      <path fill="#116e72" d="M292.72,542.74l-91.75,8.51c-4.98-5.29-9.81-10.24-14.19-15.01l104.44-9.69,1.5,16.19Z" data-id="element-399" />
      <path fill="#116e72" d="M829.09,492.96l-82.22,7.63-1.5-16.19,74.43-6.91c3.06,5.3,6.13,10.42,9.3,15.47Z" data-id="element-400" />
      <path fill="#116e72" d="M295.72,560.46l-75.63,13.09c-3.85-5.12-7.88-9.92-11.92-14.44l84.78-14.67,2.77,16.02Z" data-id="element-401" />
      <path fill="#116e72" d="M815.81,470.48l-70.66,12.22-2.77-16.03,65.15-11.28c2.84,5.27,5.58,10.27,8.28,15.09Z" data-id="element-402" />
      <path fill="#116e72" d="M300.1,577.89l-66.5,16.99c-2.65-5.15-5.58-9.99-8.68-14.57l71.16-18.18,4.02,15.76Z" data-id="element-403" />
      <path fill="#116e72" d="M804.18,449.13l-62.16,15.88-4.03-15.77,58.36-14.91c2.73,5.19,5.32,10.1,7.83,14.8Z" data-id="element-404" />
      <path fill="#116e72" d="M305.85,594.92l-63.5,21.67c-1.59-5.38-3.49-10.45-5.64-15.27l63.88-21.8,5.26,15.4Z" data-id="element-405" />
      <path fill="#116e72" d="M793.32,428.57l-55.82,19.05-5.25-15.4,53.4-18.22c2.68,5.09,5.23,9.94,7.67,14.57Z" data-id="element-406" />
      <path fill="#116e72" d="M312.91,611.44l-66.05,28.52c-.56-5.8-1.49-11.31-2.71-16.56l62.3-26.9,6.46,14.94Z" data-id="element-407" />
      <path fill="#116e72" d="M782.77,408.54l-51.13,22.08-6.46-14.93,49.94-21.56c2.68,5.01,5.22,9.81,7.65,14.41Z" data-id="element-408" />
      <path fill="#116e72" d="M321.25,627.36l-74.09,39.18c.06-2.52.14-5.08.24-7.68.14-3.73.13-7.34,0-10.86l66.25-35.03,7.61,14.38Z" data-id="element-409" />
      <path fill="#116e72" d="M772.3,388.85h0s-47.85,25.3-47.85,25.3l-7.6-14.38,47.74-25.25c2.69,4.97,5.26,9.73,7.71,14.32Z" data-id="element-410" />
      <path fill="#116e72" d="M330.82,642.58l-83.51,52.96c-.24-6.11-.34-12.46-.3-19.07l75.09-47.63,8.72,13.74Z" data-id="element-411" />
      <path fill="#116e72" d="M761.75,369.28l-45.76,29.02-8.71-13.74,46.65-29.59c2.72,4.94,5.32,9.71,7.82,14.31Z" data-id="element-412" />
      <path fill="#116e72" d="M341.56,656.99l-91.62,68.78c-.86-6-1.52-12.28-2-18.84h0s83.85-62.94,83.85-62.94l9.77,13.01Z" data-id="element-413" />
      <path fill="#116e72" d="M750.98,349.62l-44.67,33.53-9.77-13.01,46.48-34.89c2.75,4.94,5.41,9.72,7.96,14.36Z" data-id="element-414" />
      <path fill="#116e72" d="M353.39,670.51l-96.88,85.44c-1.73-5.66-3.21-11.57-4.45-17.76l90.57-79.88,10.76,12.2Z" data-id="element-415" />
      <path fill="#116e72" d="M739.88,329.66l-44.41,39.17-10.76-12.2,47.02-41.47c2.82,4.98,5.54,9.81,8.16,14.5Z" data-id="element-416" />
      <path fill="#116e72" d="M366.25,683.06l-97.94,101.14c-2.74-5.04-5.21-10.28-7.39-15.74l93.65-96.72,11.69,11.32Z" data-id="element-417" />
      <path fill="#116e72" d="M728.31,309.14l-44.78,46.25-11.69-11.31,48.07-49.65c2.89,5.04,5.69,9.94,8.4,14.72Z" data-id="element-418" />
      <path fill="#116e72" d="M380.07,694.56l-94.67,114.58c-3.63-4.34-6.98-8.79-10.06-13.37l92.18-111.58,12.55,10.37Z" data-id="element-419" />
      <path fill="#116e72" d="M716.11,287.82l-45.54,55.12-12.54-10.36,49.39-59.78c2.99,5.13,5.88,10.14,8.69,15.02Z" data-id="element-420" />
      <path fill="#116e72" d="M394.74,704.93l-88.2,125.72c-4.22-3.74-8.19-7.51-11.91-11.34l86.8-123.73,13.32,9.35Z" data-id="element-421" />
      <path fill="#116e72" d="M703.1,265.37l-46.42,66.17-13.32-9.34,50.57-72.09c2,3.14,3.96,6.34,5.89,9.64,1.11,1.89,2.2,3.76,3.28,5.62Z" data-id="element-422" />
      <path fill="#116e72" d="M410.19,714.12l-79.92,135.48c-4.55-3.33-8.89-6.63-13.02-9.95l78.93-133.8,14.01,8.26Z" data-id="element-423" />
      <path fill="#116e72" d="M688.64,242.09l-46.71,79.19-14.01-8.27,50.26-85.2c3.57,4.55,7.06,9.31,10.46,14.28Z" data-id="element-424" />
      <path fill="#116e72" d="M426.3,722.07l-70.46,144.31c-2.66-1.24-5.27-2.71-7.83-4.41-2.07-1.38-4.1-2.76-6.1-4.13l69.77-142.9,14.62,7.14Z" data-id="element-425" />
      <path fill="#116e72" d="M671.57,219.73l-45.15,92.48-14.62-7.14,47.96-98.23c4.02,4.07,7.96,8.37,11.81,12.89Z" data-id="element-426" />
      <path fill="#116e72" d="M443,728.72l-56.25,142.73c-5.92.47-11.65.26-17.19-.75l58.31-147.95,15.14,5.96Z" data-id="element-427" />
      <path fill="#116e72" d="M651.73,199.09l-41.5,105.29-15.14-5.97,43.53-110.46c4.44,3.48,8.81,7.19,13.1,11.14Z" data-id="element-428" />
      <path fill="#116e72" d="M460.17,734.04l-39.34,128.71c-6.47,2.57-12.77,4.66-18.9,6.17l42.68-139.64,15.56,4.76Z" data-id="element-429" />
      <path fill="#116e72" d="M629.21,180.99l-35.72,116.87-15.55-4.75,37.03-121.16c4.81,2.78,9.56,5.8,14.24,9.05Z" data-id="element-430" />
      <path fill="#116e72" d="M477.7,737.99l-24.12,108.95c-6.4,3.53-12.67,6.8-18.81,9.72l27.05-122.18,15.88,3.52Z" data-id="element-431" />
      <path fill="#116e72" d="M604.28,166.2l-28,126.47-15.88-3.52,28.71-129.69c5.11,2,10.17,4.24,15.17,6.74Z" data-id="element-432" />
      <path fill="#116e72" d="M495.48,740.55l-12.47,89.11c-6.07,3.72-12.05,7.32-17.93,10.75l14.29-102.12,16.11,2.26Z" data-id="element-433" />
      <path fill="#116e72" d="M577.42,155.28l-18.69,133.56-16.11-2.26,18.99-135.6c5.3,1.19,10.57,2.62,15.82,4.3Z" data-id="element-434" />
      <path fill="#116e72" d="M513.42,741.69l-.37,6.17-3.96,65.59c-5.72,3.57-11.37,7.11-16.93,10.56l5.03-83.3,16.08.97h.16Z" data-id="element-435" />
      <path fill="#116e72" d="M549.24,148.63l-8.32,137.78-16.08-.97h-.16s.38-6.29.38-6.29l7.99-132.36c5.41.37,10.81.98,16.19,1.83Z" data-id="element-436" />
    </svg>;
}
function LightTealSoundwave() {
  return <svg viewBox="0 0 1033.95 1033.95" className="absolute inset-0 w-full h-full" data-id="element-437">
      <path fill="#00b0ae" d="M518.86,285.45l-11.08.27-1.21-48.12c3.51-2.18,7.16-4.39,10.93-6.6l1.37,54.45Z" data-id="element-438" />
      <path fill="#00b0ae" d="M533.34,861.19c-3.73.67-7.42,1.25-11.06,1.73l-3.05-121.24,11.09-.28,3.01,119.79Z" data-id="element-439" />
      <path fill="#00b0ae" d="M500.91,286.17l-11.03,1.15-3.77-36.18c3.25-2.3,6.73-4.67,10.41-7.11l4.39,42.13Z" data-id="element-440" />
      <path fill="#00b0ae" d="M560.25,855.12c-3.67.99-7.29,1.9-10.86,2.74l-12.19-116.9,11.03-1.15,12.02,115.3Z" data-id="element-441" />
      <path fill="#00b0ae" d="M483.07,288.3l-10.91,2.01-5.11-27.64c3.37-1.65,6.77-3.53,10.23-5.65l5.78,31.28Z" data-id="element-442" />
      <path fill="#00b0ae" d="M586.32,847.18c-3.59,1.21-7.14,2.37-10.64,3.45l-20.65-111.8,10.91-2.01,20.39,110.36Z" data-id="element-443" />
      <path fill="#00b0ae" d="M465.45,291.83l-10.71,2.87-6.68-24.95c3.51-.9,7.02-2.03,10.57-3.4l6.82,25.48Z" data-id="element-444" />
      <path fill="#00b0ae" d="M611.6,838c-3.52,1.37-7,2.68-10.43,3.94l-28.54-106.64,10.71-2.87,28.25,105.57Z" data-id="element-445" />
      <path fill="#00b0ae" d="M448.17,296.73l-10.46,3.7-9.83-27.76c3.8-.15,7.59-.51,11.37-1.11l8.91,25.16Z" data-id="element-446" />
      <path fill="#00b0ae" d="M636.24,828c-3.46,1.46-6.88,2.89-10.26,4.27l-36.06-101.88,10.46-3.7,35.86,101.3Z" data-id="element-447" />
      <path fill="#00b0ae" d="M431.33,302.99l-10.13,4.51-16.08-36.09c4.28.59,8.5,1.01,12.68,1.21l13.52,30.37Z" data-id="element-448" />
      <path fill="#00b0ae" d="M660.44,817.38c-3.42,1.55-6.8,3.05-10.13,4.52l-43.54-97.76,10.13-4.51,43.54,97.75Z" data-id="element-449" />
      <path fill="#00b0ae" d="M415.03,310.54l-9.75,5.3-27.07-49.83c4.92,1.2,9.69,2.29,14.38,3.24l22.44,41.28Z" data-id="element-450" />
      <path fill="#00b0ae" d="M684.42,806.28c-3.39,1.6-6.74,3.18-10.06,4.72h0l-51.3-94.41,9.75-5.29,51.61,94.98Z" data-id="element-451" />
      <path fill="#00b0ae" d="M399.38,319.35l-9.29,6.05-44.07-67.78c5.5,1.43,10.8,2.85,15.96,4.21l37.4,57.52Z" data-id="element-452" />
      <path fill="#00b0ae" d="M708.47,794.71c-3.39,1.66-6.74,3.28-10.06,4.88l-59.7-91.81,9.3-6.04,60.46,92.97Z" data-id="element-453" />
      <path fill="#00b0ae" d="M384.47,329.37l-8.8,6.77-67.14-87.35c5.8,1.18,11.4,2.42,16.82,3.69h0l59.11,76.9Z" data-id="element-454" />
      <path fill="#00b0ae" d="M732.86,782.63c-3.41,1.71-6.78,3.39-10.12,5.04l-69.11-89.92,8.79-6.76,70.43,91.63Z" data-id="element-455" />
      <path fill="#00b0ae" d="M370.39,340.54l-8.24,7.43-92.09-102.06c4.23-.9,8.91-1.24,14.07-.97l86.26,95.6Z" data-id="element-456" />
      <path fill="#00b0ae" d="M757.73,769.81c-3.25,1.83-6.61,3.62-10.08,5.38l-79.94-88.6,8.24-7.43,81.78,90.64Z" data-id="element-457" />
      <path fill="#00b0ae" d="M357.23,352.77l-7.62,8.06-103.78-98.23c2.09-3.21,4.48-6.03,7.23-8.42l104.18,98.59Z" data-id="element-458" />
      <path fill="#00b0ae" d="M781.66,754.49c-2.98,2.18-6.09,4.33-9.32,6.45l-91.48-86.58,7.62-8.05,93.17,88.19Z" data-id="element-459" />
      <path fill="#00b0ae" d="M345.08,366.01l-6.97,8.63-102.35-82.62c.67-4.3,1.52-8.36,2.58-12.17l106.73,86.16Z" data-id="element-460" />
      <path fill="#00b0ae" d="M803.45,736.01c-2.6,2.58-5.34,5.12-8.21,7.64l-102.23-82.52,6.97-8.63,103.47,83.52Z" data-id="element-461" />
      <path fill="#00b0ae" d="M334.01,380.15l-6.26,9.15-93.87-64.27c-.07-4.58-.04-9.04.12-13.35l100.01,68.47Z" data-id="element-462" />
      <path fill="#00b0ae" d="M821.91,714.21c-2.09,2.98-4.32,5.93-6.69,8.85l-111.13-76.08,6.26-9.15,111.56,76.39Z" data-id="element-463" />
      <path fill="#00b0ae" d="M324.08,395.13l-5.52,9.62-82.81-47.58c-.42-4.55-.78-9.02-1.07-13.41l89.4,51.38Z" data-id="element-464" />
      <path fill="#00b0ae" d="M835.91,689.27c-1.46,3.36-3.07,6.71-4.84,10.01l-117.06-67.28,5.52-9.62,116.38,66.88Z" data-id="element-465" />
      <path fill="#00b0ae" d="M315.37,410.84l-4.75,10.02-71.48-33.9c-.58-4.39-1.12-8.74-1.62-13.04l77.85,36.92Z" data-id="element-466" />
      <path fill="#00b0ae" d="M844.7,661.86c-.78,3.67-1.7,7.33-2.78,10.96l-119.19-56.52,4.75-10.02,117.22,55.59Z" data-id="element-467" />
      <path fill="#00b0ae" d="M307.92,427.18l-3.95,10.37-61-23.24c-.62-4.2-1.23-8.39-1.82-12.56l66.77,25.44Z" data-id="element-468" />
      <path fill="#00b0ae" d="M848.11,633.01c-.11,3.87-.35,7.73-.73,11.59l-117.2-44.66,3.96-10.37,113.97,43.43Z" data-id="element-469" />
      <path fill="#00b0ae" d="M301.77,444.07l-3.12,10.65-51.89-15.22c-.61-4.03-1.23-8.07-1.83-12.1l56.84,16.67Z" data-id="element-470" />
      <path fill="#00b0ae" d="M847.77,615.75l-111.45-32.68,3.12-10.65,107.19,31.43c.5,3.95.88,7.92,1.14,11.9Z" data-id="element-471" />
      <path fill="#00b0ae" d="M296.98,461.38l-2.28,10.86-44.43-9.31c-.56-3.88-1.15-7.78-1.73-11.69l48.44,10.15Z" data-id="element-472" />
      <path fill="#00b0ae" d="M843.91,587.29l-102.79-21.53,2.27-10.86,97.81,20.49c1,3.93,1.91,7.9,2.71,11.9Z" data-id="element-473" />
      <path fill="#00b0ae" d="M293.56,479.02l-1.41,11-38.9-5c-.36-3.35-.79-6.79-1.29-10.33-.04-.34-.1-.69-.15-1.03l41.75,5.36Z" data-id="element-474" />
      <path fill="#00b0ae" d="M836.81,559.97l-92.27-11.85,1.41-11,86.9,11.16h0c1.38,3.85,2.71,7.74,3.96,11.7Z" data-id="element-475" />
      <path fill="#00b0ae" d="M291.54,496.87l-.54,11.08-36.14-1.77c-.14-3.58-.35-7.29-.67-11.14l37.35,1.83Z" data-id="element-476" />
      <path fill="#00b0ae" d="M827.39,534.23l-80.84-3.96.54-11.08,75.38,3.7c1.69,3.7,3.33,7.48,4.92,11.34Z" data-id="element-477" />
      <path fill="#00b0ae" d="M291.27,525.91l-36.5,1.09c.18-3.53.28-7.23.28-11.1l35.89-1.07.33,11.08Z" data-id="element-478" />
      <path fill="#00b0ae" d="M816.45,510.25l-69.29,2.06-.33-11.08,63.96-1.91c1.89,3.52,3.79,7.17,5.66,10.93Z" data-id="element-479" />
      <path fill="#00b0ae" d="M292.94,543.8l-40.56,4.42c.64-3.54,1.18-7.31,1.6-11.33l37.76-4.12,1.2,11.03Z" data-id="element-480" />
      <path fill="#00b0ae" d="M804.51,488.03l-58.15,6.34-1.2-11.03,53.12-5.79c2.03,3.31,4.12,6.8,6.23,10.48Z" data-id="element-481" />
      <path fill="#00b0ae" d="M296.02,561.5l-50.09,9.49c1.47-3.6,2.84-7.61,4.04-12.05l43.99-8.34,2.06,10.9Z" data-id="element-482" />
      <path fill="#00b0ae" d="M791.91,467.48l-47.76,9.06-2.07-10.9,43.1-8.17c2.06,2.97,4.32,6.32,6.74,10.01Z" data-id="element-483" />
      <path fill="#00b0ae" d="M300.49,578.9l-76.25,20.79c3.8-2.46,9.47-7.16,14.92-15.56l58.42-15.93,2.92,10.7Z" data-id="element-484" />
      <path fill="#00b0ae" d="M778.77,448.51l-38.24,10.43-2.91-10.7,33.22-9.06c.92.9,1.87,1.8,2.85,2.7,0,0,1.89,2.33,5.07,6.63Z" data-id="element-485" />
      <path fill="#00b0ae" d="M306.31,595.89l-122.2,43.9c1.84-4.74,5.23-9.85,10.36-15.51l108.08-38.83,3.76,10.43Z" data-id="element-486" />
      <path fill="#00b0ae" d="M763.87,431.5l-28.32,10.17-3.75-10.44,25.51-9.17c1.89,3.2,4.06,6.34,6.56,9.44Z" data-id="element-487" />
      <path fill="#00b0ae" d="M313.44,612.38l-121.63,54.85c-2.96-3.01-5.27-6.01-6.86-9.07l123.93-55.9,4.56,10.12Z" data-id="element-488" />
      <path fill="#00b0ae" d="M753.19,414.04l-23.98,10.82-4.56-10.11,24.79-11.18c1.01,3.56,2.25,7.05,3.76,10.47Z" data-id="element-489" />
      <path fill="#00b0ae" d="M321.86,628.25l-105.32,57.88c-3.68-2.41-7.13-4.73-10.31-7l110.28-60.6,5.35,9.72Z" data-id="element-490" />
      <path fill="#00b0ae" d="M747.32,394.45l-25.74,14.15-5.35-9.72,29.53-16.22c.35,4.02.86,7.96,1.56,11.8Z" data-id="element-491" />
      <path fill="#00b0ae" d="M331.49,643.42l-89.57,58.84c-3.54-2.25-6.98-4.41-10.29-6.51l93.77-61.6,6.09,9.27Z" data-id="element-492" />
      <path fill="#00b0ae" d="M745.13,371.68h0s-32.43,21.31-32.43,21.31l-6.09-9.27,38.38-25.21c-.01,4.5.01,8.88.15,13.17Z" data-id="element-493" />
      <path fill="#00b0ae" d="M342.29,657.77l-77.03,59.79c-3.29-2.25-6.54-4.41-9.71-6.5l79.94-62.05,6.8,8.76Z" data-id="element-494" />
      <path fill="#00b0ae" d="M745.2,331.02c.01,4.82-.04,9.52-.09,14.12l-42.5,32.99-6.8-8.76,49.4-38.34Z" data-id="element-495" />
      <path fill="#00b0ae" d="M354.19,671.24l-67.61,61.59c-3.07-2.31-6.11-4.55-9.11-6.71l69.25-63.08,7.47,8.2Z" data-id="element-496" />
      <path fill="#00b0ae" d="M744.91,315.34l-53.54,48.76-7.47-8.2,60.13-54.77c.41,4.84.69,9.58.87,14.21Z" data-id="element-497" />
      <path fill="#00b0ae" d="M367.11,683.72l-60.79,64.84c-2.88-2.42-5.74-4.77-8.59-7.05l61.29-65.37,8.09,7.59Z" data-id="element-498" />
      <path fill="#00b0ae" d="M742.01,283.89l-62.93,67.11-8.09-7.59,68.55-73.1c.98,4.61,1.8,9.14,2.47,13.58Z" data-id="element-499" />
      <path fill="#00b0ae" d="M380.96,695.15l-56.03,70.08c-2.73-2.58-5.45-5.1-8.16-7.55l55.53-69.46,8.66,6.93Z" data-id="element-500" />
      <path fill="#00b0ae" d="M734.97,252.38h0s-69.18,86.53-69.18,86.53l-8.66-6.93,73.72-92.2c1.53,4.27,2.9,8.47,4.13,12.59Z" data-id="element-501" />
      <path fill="#00b0ae" d="M395.69,705.45l-52.82,77.93c-2.6-2.81-5.22-5.55-7.85-8.21l51.48-75.95,9.18,6.23Z" data-id="element-502" />
      <path fill="#00b0ae" d="M723.25,222.2l-71.65,105.71-9.18-6.22,74.26-109.54c2.37,3.05,4.57,6.4,6.58,10.06Z" data-id="element-503" />
      <path fill="#00b0ae" d="M411.17,714.56l-50.02,87.98c-2.68-2.65-5.38-5.38-8.09-8.21l48.46-85.25,9.65,5.48Z" data-id="element-504" />
      <path fill="#00b0ae" d="M703.95,199.53l-67.37,118.52-9.64-5.48,67.62-118.97c3.28,1.71,6.41,3.67,9.39,5.92Z" data-id="element-505" />
      <path fill="#00b0ae" d="M427.32,722.43l-46.08,98.36c-2.91-2.41-5.81-4.92-8.73-7.54l44.76-95.53,10.05,4.7Z" data-id="element-506" />
      <path fill="#00b0ae" d="M677.96,187.44l-57.14,121.97-10.05-4.7,55.89-119.29c3.87.45,7.64,1.12,11.3,2.03Z" data-id="element-507" />
      <path fill="#00b0ae" d="M444.04,729l-40.66,108.21c-3.14-2.04-6.27-4.2-9.41-6.49l39.68-105.63,10.38,3.9Z" data-id="element-508" />
      <path fill="#00b0ae" d="M648.49,184.79l-44.05,117.25-10.38-3.9,42.2-112.33c4.13-.51,8.22-.85,12.23-1.01Z" data-id="element-509" />
      <path fill="#00b0ae" d="M461.22,734.24l-33.54,116.38c-3.39-1.53-6.75-3.19-10.1-4.99l32.99-114.46,10.66,3.08Z" data-id="element-510" />
      <path fill="#00b0ae" d="M618.38,188.9l-30.85,107.07-10.66-3.08,29.08-100.88c4.16-1.17,8.31-2.21,12.44-3.12Z" data-id="element-511" />
      <path fill="#00b0ae" d="M478.77,738.1l-24.91,121.76c-3.59-.91-7.15-1.96-10.68-3.14l24.72-120.84,10.87,2.22Z" data-id="element-512" />
      <path fill="#00b0ae" d="M589.43,197.2l-19.24,94.05-10.86-2.22,17.86-87.3c4.06-1.6,8.15-3.11,12.25-4.53Z" data-id="element-513" />
      <path fill="#00b0ae" d="M496.56,740.58l-15.31,123.76c-3.72-.28-7.39-.68-11.03-1.21l15.32-123.91,11.01,1.36Z" data-id="element-514" />
      <path fill="#00b0ae" d="M562.43,207.9l-9.89,80.02-11.01-1.36,9.05-73.18c3.9-1.87,7.85-3.7,11.85-5.47Z" data-id="element-515" />
      <path fill="#00b0ae" d="M514.5,741.64l-5.44,122.66c-3.76.28-7.46.45-11.12.52l5.48-123.66,11.08.49Z" data-id="element-516" />
      <path fill="#00b0ae" d="M537.61,219.87l-2.93,66.11-11.08-.49,2.63-59.48c3.7-2.07,7.51-4.12,11.38-6.15Z" data-id="element-517" />
    </svg>;
}
function ResvrLogo() {
  return <svg viewBox="0 0 1033.95 1033.95" className="absolute inset-0 w-full h-full" data-id="element-518">
      <path fill="#1e2031" d="M621.79,461.85v155.56h-104.02c-5.83,0-11.4-2.36-15.46-6.55l-27.49-28.38h16.78l20.52,20.64c1.42,1.43,3.35,2.23,5.36,2.23h92.94v-138.01l-89.03-78.94-88.71,78.64v32.24h75.17c7.81,0,14.15,6.34,14.15,14.15v37.22c0,7.81-6.34,14.15-14.15,14.15h-76.11v52.59h-12.06v-52.8c0-6.41,5.2-11.6,11.6-11.6h76.61c.97,0,1.76-.79,1.76-1.76v-38.21c0-.97-.79-1.76-1.76-1.76h-75.3c-6.46,0-11.7-5.25-11.69-11.71l.07-37.72,100.4-89.18h0s0,0,0,0l100.37,89.16.03.02Z" data-id="element-519" />
      <polygon fill="#1e2031" points="521.39 372.66 521.39 372.67 521.39 372.66 521.39 372.66" data-id="element-520" />
      <polygon fill="#1e2031" points="521.39 372.66 521.38 372.67 521.38 372.66 521.39 372.66" data-id="element-521" />
      <polygon fill="#1e2031" points="621.79 461.83 621.79 461.85 621.76 461.83 621.79 461.83" data-id="element-522" />
    </svg>;
}
// ─── Layered Orb Alt Component ───
function OrbAltAvatar({
  voiceState
}: {
  voiceState: VoiceState;
}) {
  // Each layer gets different animation params based on voice state
  const getLayerAnimation = (layer: 'black' | 'darkTeal' | 'lightTeal') => {
    const base = {
      rotate: 0,
      scale: 1
    };
    if (voiceState === 'idle') {
      switch (layer) {
        case 'black':
          return {
            rotate: [0, 1, -1, 0],
            scale: [1, 1.01, 1]
          };
        case 'darkTeal':
          return {
            rotate: [0, -1.5, 1, 0],
            scale: [1, 1.015, 1]
          };
        case 'lightTeal':
          return {
            rotate: [0, 2, -1.5, 0],
            scale: [1, 1.02, 1]
          };
      }
    }
    if (voiceState === 'listening') {
      switch (layer) {
        case 'black':
          return {
            rotate: [0, 3, -2, 0],
            scale: [1, 1.03, 0.98, 1]
          };
        case 'darkTeal':
          return {
            rotate: [0, -4, 3, 0],
            scale: [1, 1.04, 0.97, 1]
          };
        case 'lightTeal':
          return {
            rotate: [0, 5, -3, 0],
            scale: [1, 1.05, 0.96, 1]
          };
      }
    }
    // speaking
    switch (layer) {
      case 'black':
        return {
          rotate: [0, 6, -5, 3, 0],
          scale: [1, 1.06, 0.95, 1.04, 1]
        };
      case 'darkTeal':
        return {
          rotate: [0, -8, 6, -3, 0],
          scale: [1, 1.08, 0.93, 1.05, 1]
        };
      case 'lightTeal':
        return {
          rotate: [0, 10, -7, 5, 0],
          scale: [1, 1.1, 0.92, 1.06, 1]
        };
    }
  };
  const getDuration = () => {
    if (voiceState === 'idle') return 4;
    if (voiceState === 'listening') return 2;
    return 1.2;
  };
  return <div className="relative w-52 h-52" data-id="element-523">
      {/* Layer 1: Black Soundwave (back) */}
      <motion.div className="absolute inset-0" animate={getLayerAnimation('black')} transition={{
      duration: getDuration(),
      repeat: Infinity,
      ease: 'easeInOut'
    }} style={{
      transformOrigin: '50.3% 50.5%'
    }} data-id="element-524">
        <BlackSoundwave data-id="element-525" />
      </motion.div>

      {/* Layer 2: Dark Teal Soundwave */}
      <motion.div className="absolute inset-0" animate={getLayerAnimation('darkTeal')} transition={{
      duration: getDuration() * 1.1,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.1
    }} style={{
      transformOrigin: '50.3% 50.5%'
    }} data-id="element-526">
        <DarkTealSoundwave data-id="element-527" />
      </motion.div>

      {/* Layer 3: Gradient Background Circle */}
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-528">
        <motion.div animate={{
        scale: voiceState === 'speaking' ? [1, 1.03, 1] : 1
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-529">
          <svg viewBox="0 0 1033.95 1033.95" className="w-52 h-52" data-id="element-530">
            <defs data-id="element-531">
              <linearGradient id="orb-gradient" x1="520.74" y1="314.44" x2="520.74" y2="710.18" gradientUnits="userSpaceOnUse" data-id="element-532">
                <stop offset="0" stopColor="#fff" data-id="element-533" />
                <stop offset="1" stopColor="#3dfff7" data-id="element-534" />
              </linearGradient>
            </defs>
            <circle cx="520.74" cy="512.31" r="197.87" fill="url(#orb-gradient)" data-id="element-535" />
          </svg>
        </motion.div>
      </div>

      {/* Layer 4: Light Teal Soundwave */}
      <motion.div className="absolute inset-0" animate={getLayerAnimation('lightTeal')} transition={{
      duration: getDuration() * 0.9,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.2
    }} style={{
      transformOrigin: '50.3% 50.5%'
    }} data-id="element-536">
        <LightTealSoundwave data-id="element-537" />
      </motion.div>

      {/* Layer 5: ResVR Logo (top) */}
      <div className="absolute inset-0" data-id="element-538">
        <ResvrLogo data-id="element-539" />
      </div>
    </div>;
}
// ─── Main Component ───
export function AssistantOverlay({
  isActive,
  onDeactivate
}: AssistantOverlayProps) {
  const {
    isDark
  } = useTheme();
  const [avatarType, setAvatarType] = useState<AvatarType>('orb-alt');
  const [voiceState, setVoiceState] = useState<VoiceState>('idle');
  const [isMuted, setIsMuted] = useState(false);
  const [currentText, setCurrentText] = useState('');
  const [displayedText, setDisplayedText] = useState('');
  const [currentSpeaker, setCurrentSpeaker] = useState<'ai' | 'you'>('ai');
  const [conversationIndex, setConversationIndex] = useState(0);
  const typingRef = useRef<NodeJS.Timeout | null>(null);
  // Mock conversation cycle
  useEffect(() => {
    if (!isActive) {
      setConversationIndex(0);
      setVoiceState('idle');
      setDisplayedText('');
      setCurrentText('');
      return;
    }
    const step = MOCK_CONVERSATION[conversationIndex];
    setVoiceState(step.state);
    setCurrentText(step.text);
    setCurrentSpeaker(step.speaker);
    if (step.state === 'speaking') {
      setDisplayedText('');
      let charIndex = 0;
      const typeInterval = setInterval(() => {
        if (charIndex < step.text.length) {
          setDisplayedText(step.text.slice(0, charIndex + 1));
          charIndex++;
        } else {
          clearInterval(typeInterval);
        }
      }, 25);
      typingRef.current = typeInterval as any;
      const timer = setTimeout(() => {
        clearInterval(typeInterval);
        setConversationIndex(prev => (prev + 1) % MOCK_CONVERSATION.length);
      }, step.duration);
      return () => {
        clearTimeout(timer);
        clearInterval(typeInterval);
      };
    } else {
      setDisplayedText(step.text);
      const timer = setTimeout(() => {
        setConversationIndex(prev => (prev + 1) % MOCK_CONVERSATION.length);
      }, step.duration);
      return () => clearTimeout(timer);
    }
  }, [isActive, conversationIndex]);
  // Generate random bar heights for simple orb visualizer
  const [barHeights, setBarHeights] = useState<number[]>(() => Array.from({
    length: 56
  }, () => 0.3 + Math.random() * 0.7));
  useEffect(() => {
    if (!isActive || avatarType !== 'orb') return;
    const interval = setInterval(() => {
      setBarHeights(prev => prev.map(() => {
        if (voiceState === 'speaking') return 0.3 + Math.random() * 0.7;
        if (voiceState === 'listening') return 0.2 + Math.random() * 0.5;
        return 0.25 + Math.random() * 0.25;
      }));
    }, voiceState === 'speaking' ? 100 : voiceState === 'listening' ? 150 : 400);
    return () => clearInterval(interval);
  }, [isActive, avatarType, voiceState]);
  const barColors = ['#0d9488', '#14b8a6', '#0f766e', '#115e59'];
  // Shared controls renderer
  const renderControls = () => <div className="flex items-center gap-3" data-id="element-540">
      <button onClick={() => setIsMuted(!isMuted)} className={`relative w-14 h-14 rounded-full flex items-center justify-center transition-all shadow-lg ${isMuted ? isDark ? 'bg-slate-700 text-slate-400' : 'bg-gray-200 text-gray-500' : isDark ? 'bg-cyan-500 text-white' : 'bg-teal-600 text-white'}`} data-id="element-541">
        {voiceState === 'listening' && !isMuted && <motion.div animate={{
        scale: [1, 1.5, 1],
        opacity: [0.6, 0, 0.6]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className={`absolute inset-0 rounded-full ${isDark ? 'bg-cyan-500/30' : 'bg-teal-500/30'}`} data-id="element-542" />}
        {isMuted ? <MicOff className="w-6 h-6" data-id="element-543" /> : <Mic className="w-6 h-6" data-id="element-544" />}
      </button>
      <button onClick={onDeactivate} className={`flex items-center gap-2 px-4 py-2.5 rounded-full border transition-colors ${isDark ? 'border-white/15 text-white/60 hover:text-white hover:bg-white/10' : 'border-gray-300 text-gray-500 hover:text-gray-900 hover:bg-gray-100'}`} data-id="element-545">
        <X className="w-3.5 h-3.5" data-id="element-546" />
        <span className="text-xs font-bold uppercase tracking-wider" data-id="element-547">End</span>
      </button>
    </div>;
  return <AnimatePresence data-id="element-548">
      {isActive && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.4
    }} className="fixed inset-0 z-[55] pointer-events-none" data-id="element-549">
          {/* Dev Toggle Pill */}
          <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3
      }} className={`absolute top-20 left-28 z-10 pointer-events-auto flex items-center rounded-full p-0.5 text-[10px] font-bold uppercase tracking-wider border ${isDark ? 'bg-slate-800/80 border-white/10' : 'bg-white/80 border-gray-200'}`} data-id="element-550">
            <button onClick={() => setAvatarType('human')} className={`px-3 py-1 rounded-full transition-colors ${avatarType === 'human' ? isDark ? 'bg-cyan-500/20 text-cyan-400' : 'bg-teal-100 text-teal-700' : isDark ? 'text-slate-500' : 'text-gray-400'}`} data-id="element-551">
              Human
            </button>
            <button onClick={() => setAvatarType('orb')} className={`px-3 py-1 rounded-full transition-colors ${avatarType === 'orb' ? isDark ? 'bg-cyan-500/20 text-cyan-400' : 'bg-teal-100 text-teal-700' : isDark ? 'text-slate-500' : 'text-gray-400'}`} data-id="element-552">
              Orb
            </button>
            <button onClick={() => setAvatarType('orb-alt')} className={`px-3 py-1 rounded-full transition-colors ${avatarType === 'orb-alt' ? isDark ? 'bg-cyan-500/20 text-cyan-400' : 'bg-teal-100 text-teal-700' : isDark ? 'text-slate-500' : 'text-gray-400'}`} data-id="element-553">
              Orb Alt
            </button>
          </motion.div>

          {/* Avatar Area — Bottom Right */}
          <div className="absolute bottom-8 right-8 pointer-events-auto flex flex-col items-center gap-4" data-id="element-554">
            <AnimatePresence mode="wait" data-id="element-555">
              {avatarType === 'human' ? <motion.div key="human-avatar" initial={{
            opacity: 0,
            scale: 0.8,
            y: 30
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.8,
            y: 30
          }} transition={{
            duration: 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex flex-col items-center gap-3" data-id="element-556">
                  <div className="relative" data-id="element-557">
                    {voiceState === 'speaking' && <motion.div animate={{
                opacity: [0.4, 0.8, 0.4],
                scale: [1, 1.04, 1]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute -inset-1.5 rounded-2xl bg-gradient-to-br from-cyan-400/40 to-teal-500/40 blur-sm" data-id="element-558" />}
                    <div className={`relative w-48 h-56 rounded-2xl overflow-hidden shadow-2xl border-2 ${voiceState === 'speaking' ? 'border-cyan-400/60' : isDark ? 'border-white/10' : 'border-white/40'}`} data-id="element-559">
                      <img src="https://cdn.magicpatterns.com/uploads/tGmFZULS5JvnVL7Y5cdHrX/Zight_2026-02-13_at_4.54.05_AM.jpg" alt="AI Assistant" className="w-full h-full object-cover" data-id="element-560" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" data-id="element-561" />
                    </div>
                  </div>
                  <span className={`text-[10px] font-bold uppercase tracking-[0.2em] ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-562">
                    RESVR Assistant
                  </span>
                  {renderControls()}
                </motion.div> : avatarType === 'orb' ? <motion.div key="orb-avatar" initial={{
            opacity: 0,
            scale: 0.8,
            y: 30
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.8,
            y: 30
          }} transition={{
            duration: 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex flex-col items-center gap-3" data-id="element-563">
                  <div className="relative w-48 h-48" data-id="element-564">
                    <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full" data-id="element-565">
                      {barHeights.map((height, i) => {
                  const angle = i / barHeights.length * 360 - 90;
                  const rad = angle * Math.PI / 180;
                  const innerRadius = 52;
                  const barLength = 14 + height * 22;
                  const x1 = 100 + Math.cos(rad) * innerRadius;
                  const y1 = 100 + Math.sin(rad) * innerRadius;
                  const x2 = 100 + Math.cos(rad) * (innerRadius + barLength);
                  const y2 = 100 + Math.sin(rad) * (innerRadius + barLength);
                  const color = barColors[i % barColors.length];
                  return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth={3.5} strokeLinecap="round" data-id="element-566" />;
                })}
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-567">
                      <motion.div animate={{
                  scale: voiceState === 'speaking' ? [1, 1.03, 1] : 1
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="w-24 h-24 rounded-full bg-gradient-to-br from-cyan-200 via-cyan-300 to-cyan-500 flex items-center justify-center shadow-lg" style={{
                  boxShadow: '0 0 0 4px white, 0 0 30px rgba(6, 182, 212, 0.3)'
                }} data-id="element-568">
                        <svg viewBox="380 330 290 310" className="w-12 h-12" data-id="element-569">
                          <path d="M621.79,461.85v155.56h-104.02c-5.83,0-11.4-2.36-15.46-6.55l-27.49-28.38h16.78l20.52,20.64c1.42,1.43,3.35,2.23,5.36,2.23h92.94v-138.01l-89.03-78.94-88.71,78.64v32.24h75.17c7.81,0,14.15,6.34,14.15,14.15v37.22c0,7.81-6.34,14.15-14.15,14.15h-76.11v52.59h-12.06v-52.8c0-6.41,5.2-11.6,11.6-11.6h76.61c.97,0,1.76-.79,1.76-1.76v-38.21c0-.97-.79-1.76-1.76-1.76h-75.3c-6.46,0-11.7-5.25-11.69-11.71l.07-37.72,100.4-89.18h0s0,0,0,0l100.37,89.16.03.02Z" fill="#1e3a5f" data-id="element-570" />
                          <polygon fill="#1e3a5f" points="521.39 372.66 521.39 372.67 521.39 372.66 521.39 372.66" data-id="element-571" />
                          <polygon fill="#1e3a5f" points="521.39 372.66 521.38 372.67 521.38 372.66 521.39 372.66" data-id="element-572" />
                          <polygon fill="#1e3a5f" points="621.79 461.83 621.79 461.85 621.76 461.83 621.79 461.83" data-id="element-573" />
                        </svg>
                      </motion.div>
                    </div>
                  </div>
                  <span className={`text-[10px] font-bold uppercase tracking-[0.2em] ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-574">
                    RESVR AI
                  </span>
                  {renderControls()}
                </motion.div> : <motion.div key="orb-alt-avatar" initial={{
            opacity: 0,
            scale: 0.8,
            y: 30
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.8,
            y: 30
          }} transition={{
            duration: 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex flex-col items-center gap-3" data-id="element-575">
                  <OrbAltAvatar voiceState={voiceState} data-id="element-576" />
                  <span className={`text-[10px] font-bold uppercase tracking-[0.2em] ${isDark ? 'text-white/50' : 'text-gray-500'}`} data-id="element-577">
                    RESVR AI
                  </span>
                  {renderControls()}
                </motion.div>}
            </AnimatePresence>
          </div>

          {/* Transcript Area — Bottom Center */}
          <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} transition={{
        delay: 0.2,
        duration: 0.3
      }} className="absolute bottom-8 left-1/2 -translate-x-1/2 pointer-events-none max-w-lg w-full px-4" data-id="element-578">
            <div className={`rounded-xl px-5 py-3.5 backdrop-blur-xl border shadow-2xl ${isDark ? 'bg-slate-900/80 border-white/10' : 'bg-white/80 border-white/40'}`} data-id="element-579">
              <div className="flex items-center gap-2 mb-1.5" data-id="element-580">
                {voiceState === 'listening' ? <div className="flex items-center gap-1.5" data-id="element-581">
                    <div className={`w-1.5 h-1.5 rounded-full animate-pulse ${isDark ? 'bg-cyan-400' : 'bg-teal-500'}`} data-id="element-582" />
                    <span className={`text-[10px] font-bold uppercase tracking-wider ${isDark ? 'text-cyan-400' : 'text-teal-600'}`} data-id="element-583">
                      You
                    </span>
                  </div> : <div className="flex items-center gap-1.5" data-id="element-584">
                    <Sparkles className={`w-3 h-3 ${isDark ? 'text-cyan-400' : 'text-teal-600'}`} data-id="element-585" />
                    <span className={`text-[10px] font-bold uppercase tracking-wider ${isDark ? 'text-cyan-400' : 'text-teal-600'}`} data-id="element-586">
                      RESVR AI
                    </span>
                  </div>}
                {voiceState === 'speaking' && <div className="flex items-center gap-0.5 ml-auto" data-id="element-587">
                    {[0, 1, 2, 3].map(i => <motion.div key={i} animate={{
                height: [3, 10, 3]
              }} transition={{
                duration: 0.6,
                repeat: Infinity,
                delay: i * 0.1
              }} className={`w-[2px] rounded-full ${isDark ? 'bg-cyan-400' : 'bg-teal-500'}`} data-id="element-588" />)}
                  </div>}
              </div>
              <p className={`text-sm leading-relaxed ${isDark ? 'text-white/80' : 'text-gray-700'}`} data-id="element-589">
                {voiceState === 'speaking' ? displayedText : currentText}
                {voiceState === 'speaking' && displayedText.length < currentText.length && <motion.span animate={{
              opacity: [1, 0, 1]
            }} transition={{
              duration: 0.8,
              repeat: Infinity
            }} className={`inline-block w-0.5 h-4 ml-0.5 align-middle ${isDark ? 'bg-cyan-400' : 'bg-teal-600'}`} data-id="element-590" />}
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}